import { EN, FR, useLanguage } from '../context/LanguageContext';
import trans from '../translation/translations.json';

export default function GetLangConfig(view: string){
    
    let userLang = useLanguage();
    if (!userLang) {
        if (navigator.language?.startsWith(FR)) {
            userLang = FR;
        } else {
            userLang = EN;
        }
    }

    return trans[userLang as keyof typeof trans];
    
}